import { globalEnvironment } from './environment.global';

/**
 * Cognito multi-Region UAT  (environment input: cognito-uat-ind)
 *
 * DISTINCT FROM environment.uat.ts, which belongs to the older UAT environment on the UAT-bo
 * cluster. This one targets the Terraform-managed stack in ap-south-1 with DR in ap-south-2:
 *
 *   cluster        np-cognito-ind-uat-ecs-cluster
 *   ECR namespace  np-cognito-ind-uat/...
 *   SSM prefix     uat-ind-*
 *   user pool      ap-south-1_WfVqejCjf   (replicated to ap-southeast-1)
 *
 * WHY THIS FILE HAS TO EXIST AT ALL
 *
 * These values are baked into the bundle at BUILD time, not read at runtime. Replicating the dev
 * image into UAT would therefore give a UAT frontend that authenticates against the DEV pool and
 * calls the DEV API. The two frontends are the only images in this platform that are genuinely
 * environment-specific; the backends take their configuration from SSM at runtime.
 *
 * The hostnames are the DR failover names, so they are identical whichever region is serving:
 * Route 53 points auth.cognito-uat.nephroplus.com at Mumbai's ALB while it is healthy and at
 * Hyderabad's when it is not. Nothing here changes on failover.
 */
export const environment = {
  production: true,

  // Failover alias pair in Route 53 -> Mumbai ALB (primary) / Hyderabad ALB (secondary).
  apiBaseUrl: 'https://auth.cognito-uat.nephroplus.com/api',
  reportAPIBaseUrl: 'https://auth.cognito-uat.nephroplus.com/api',

  // Port 9443 is the WebSocket listener on the ALB - a separate target group from 443.
  socketURL: 'wss://auth.cognito-uat.nephroplus.com:9443/ws',

  ...globalEnvironment,

  cognito: {
    // The pool created by Terraform 14_cognito. Multi-Region replication shares this ID with the
    // Singapore replica, so it stays correct during a Mumbai outage.
    userPoolId: 'ap-south-1_WfVqejCjf',

    // ⚠️  MUST BE FILLED IN before the first frontend build.
    //
    // Terraform generates this and does not know it in advance. Read it with:
    //
    //   aws cognito-idp list-user-pool-clients \
    //     --user-pool-id ap-south-1_WfVqejCjf --region ap-south-1 \
    //     --query "UserPoolClients[?ClientName=='np-cognito-ind-uat-client'].ClientId" --output text
    //
    // or from the 14_cognito stack's user_pool_client_ids output.
    clientId: '1gnihng0eb1fqu4pis1aq987nk',

    // The CUSTOM domain, not the np-nephroplus-ind-uat.auth.<region>.amazoncognito.com prefix.
    // Only a custom domain can fail over to the Singapore replica - prefix domains are
    // Region-isolated, which is the whole reason 14_cognito creates one.
    domain: 'login.cognito-uat.nephroplus.com',

    // Must match the callback_urls / logout_urls on np-cognito-ind-uat-client exactly. Cognito
    // rejects a redirect that is not registered, character for character.
    redirectUri: 'https://auth.cognito-uat.nephroplus.com/bo',
    logoutUri: 'https://auth.cognito-uat.nephroplus.com/bo',

    scope: 'openid email profile',
    responseType: 'code',
  },
};
